import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { Suspense, lazy } from 'react';

const TanStackRouterDevtools =
	import.meta.env.MODE === 'production'
		? () => null
		: lazy(() =>
				import('@tanstack/react-devtools').then((res) => ({
					default: res.TanStackDevtools,
				})),
			);

export default function Devtools() {
	return (
		<Suspense fallback="loading...">
			<TanStackRouterDevtools
				config={{
					position: 'bottom-left',
				}}
				plugins={[
					{
						name: 'Tanstack Router',
						render: <TanStackRouterDevtoolsPanel />,
					},
				]}
			/>
		</Suspense>
	);
}
